module.exports = __webpack_public_path__ + "static/media/ic_options.22f631e4.svg";